export const generateRandomValue = () => {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	let randomValue = ''
	
	for (let i = 0; i < 6; i++) {
		const randomIndex = Math.floor(Math.random() * characters.length)
		randomValue += characters[randomIndex]
	}
	return randomValue
}

export const filterGroupsNodesInLevels = (levels, node, replace) => {
	const filteredGroupsNodesInLevels = levels?.map((lvl) => {
		const filteredGroups = lvl?.groups?.map((grp) => {
			let updatedNodes = null

			if (replace) {
				updatedNodes = grp?.nodes?.map((n) => {
					if (node?.nodeUid === n?.nodeUid && replace) {
						return {
							color: 'white',
							name: '---',
							nodeUid: generateRandomValue(),
							orderNumber: 0,
							playerUid: null,
							rating: '-',
						} 
					}

					return n
				})
			} else {
				updatedNodes = grp?.nodes?.filter((n) => node?.nodeUid !== n?.nodeUid)
			}
			return { ...grp, nodes: updatedNodes }
		})
		return { ...lvl, groups: filteredGroups }
	})
	return filteredGroupsNodesInLevels
}

export const assignAlphabeticalNames = (stage) => {
	let counter = 0
	const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

	const levelsWithNamedGroups = stage?.levels?.map(l => {
		const namedGroups = l?.groups?.map((g, index) => {
			if (g.name === null) {
				const namedGroup = { ...g, name: alphabet[counter] }
				counter++
				return namedGroup
			} else {
				return g
			}
		})
		return { ...l, groups: namedGroups }
	})
	return { ...stage, levels: levelsWithNamedGroups }
}

const formSearchableWord = (word) => {
	// form searchable word
	return word?.toLowerCase().replace(/ /g, '').replace(/ё/, 'е')
}

export const findPlayers = (searchText, listOfPlayers) => {
	// looking for participants through the search
	if (searchText === '') {
		return listOfPlayers
	} else {
		return listOfPlayers?.filter((player) => {
			return formSearchableWord(player?.first_name).startsWith(formSearchableWord(searchText)) ||
        formSearchableWord(player?.last_name).startsWith(formSearchableWord(searchText)) ||
        formSearchableWord(`${player?.last_name} ${player?.first_name}`).startsWith(formSearchableWord(searchText)) ||
        formSearchableWord(`${player?.first_name} ${player?.last_name}`).startsWith(formSearchableWord(searchText))
		})
	}
}

export const checkEquality = (obj1, obj2) => {
	if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
		return obj1 === obj2
	}

	const keys1 = Object.keys(obj1)
	const keys2 = Object.keys(obj2)

	if (keys1.length !== keys2.length) {
		return false
	}

	for (const key of keys1) {
		if (!keys2.includes(key)) {
			return false
		}

		if (!checkEquality(obj1[key], obj2[key])) {
			return false
		}
	}

	return true
}